import type { DecisionRow } from "@/api/client.js";

const IPV4 =
  /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;

/** Basic IPv4 / bracketed IPv6 validation (no zone id). */
export function isValidIp(raw: string): boolean {
  const s = raw.trim();
  if (!s) return false;
  if (IPV4.test(s)) return true;
  if (!s.includes(":")) return false;
  try {
    const u = new URL(`http://[${s}]/`);
    return Boolean(u.hostname);
  } catch {
    return false;
  }
}

function isBanRow(row: DecisionRow): boolean {
  return row.type === undefined || row.type === "" || row.type === "ban";
}

export type DecisionMatchScope = "bans" | "all";

function norm(s: string): string {
  return s.trim().toLowerCase();
}

export function matchDecisions(
  rows: DecisionRow[],
  q: string,
  opts?: { matchScope?: DecisionMatchScope }
): { exact: DecisionRow[]; partial: DecisionRow[] } {
  const needle = norm(q);
  if (!needle) return { exact: [], partial: [] };
  const scope = opts?.matchScope ?? "bans";
  const pool = scope === "all" ? rows : rows.filter(isBanRow);
  const exact = pool.filter((r) => norm(r.value ?? "") === needle);
  const partial = pool.filter((r) => {
    const v = norm(r.value ?? "");
    return v.includes(needle) && v !== needle;
  });
  return { exact, partial };
}
